webpackJsonp([263791100135453],{

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(30);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Headers = __webpack_require__(46);
	
	var _typography = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var container = {
	  margin: '0 auto',
	  maxWidth: 960,
	  padding: (0, _typography.rhythm)(1) + ' ' + (0, _typography.rhythm)(3 / 4),
	  paddingTop: 0
	};
	
	var About = function About() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      { style: container },
	      _react2.default.createElement(
	        'div',
	        { className: 'mobile-h1' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'About'
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          _Headers.Header2,
	          { color: '#161f4b' },
	          'About Quality Link Consulting'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'section',
	            { className: 'eight columns' },
	            _react2.default.createElement(
	              _Headers.Header3,
	              { color: '#3348b1' },
	              'Quality Link Consulting supports the Biotechnology, pharmaceutical, and Medical Device industries'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We provide support for bringing products to market in a compliance driven manner. From Phase I through approval, consultants use a practical approach to Quality Management.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Quality Link Consulting has provided Quality management and auditing support for small, mid-size, and large pharmaceutical companies as well as a start-up clinical technology company. Inspection experience includes FDA, EMA, and MHRA.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Quality Link Consulting specializes in Quality Assurance Audits, Quality Management System implementation and support, non-compliance investigations and CAPA, Vendor Management, inspection readiness and inspection support.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contact/' },
	                'Please click here to contact us for your specific business needs.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            { className: 'four columns' },
	            _react2.default.createElement(
	              _Headers.Header3,
	              { color: '#3348b1' },
	              'Quality Link Consulting\u2019s industry experience includes'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'GCP, GLP, and GMP in Biologics, Pharmaceuticals, and Medical Devices. Early to late phase clinical programs as well as post-marketing studies and registries in the following disease areas:'
	            ),
	            _react2.default.createElement(
	              'uL',
	              { className: 'quality-link-icon' },
	              _react2.default.createElement(
	                'li',
	                null,
	                'Rare/Orphan Diseases'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Oncology'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Rheumatology'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Ophthalmology'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-2ee6c11d0f298367c9dd.js